import { Breakpoints, css, styled, ThemeDefinition } from "@vw-marketing/us-components";

interface ModelCardContainerProps {
  carImage: string;
  theme: ThemeDefinition;
}

export const ModelCardContainer: any = styled.div`
  ${({ theme, carImage }: ModelCardContainerProps) => {
    return css`
      background: ${theme.colors.background.highlight};
      display: flex;
      flex-direction: column;
      justify-content: stretch;
      margin-bottom: 60px;
      min-height: 232px;
      padding: ${theme.size.static450} ${theme.size.grid002} ${carImage ? 0 : theme.size.static450} ${theme.size.grid002};
      position: relative;
      width: ${theme.size.grid024};

      @media (min-width: ${Breakpoints.b560}px) {
        padding-top: ${theme.size.static510};
      }

      @media (min-width: ${Breakpoints.b1920}px) {
        flex-direction: row;
        height: 317px;
        padding-top: ${theme.size.static600};
      }
    `;
  }}
`;

export const ModelCardInfoSection: any = styled.div`
  flex-direction: column;
  width: 100%;
`;

export const TrimInfoContainer: any = styled.div`
  p {
    color: #3C484D;
  }
`;

export const ChangeVehicleCTAContainer: any = styled.div`
  padding-top: ${({ theme }) => theme.size.static100};
  width: max-content;

  @media (min-width: ${Breakpoints.b560}px) {
    padding-top: ${({ theme }) => theme.size.static150};
  }

  @media (min-width: ${Breakpoints.b960}px) {
    padding-top: ${({ theme }) => theme.size.static300};
  }
`;

export const ModelCardImageContainer: any = styled.div`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 40%);
  max-width: 500px;
  width: 100%;
  pointer-events: none;

  img {
    height: auto;
    min-width: 287px;
    max-width: 500px;
    width: 100%;
  }

  @media (min-width: ${Breakpoints.b560}px) {
    left: auto;
    right: ${({ theme }) => theme.size.grid002};
    transform: translateY(40%);
  }

  @media (min-width: ${Breakpoints.b1920}px) {
    max-width: 600px;

    img {
      max-width: 600px;
    }
  }
`;
